import { DateTime } from 'luxon';
import { displayMessage } from '../../../services/helper';

export default [
    {
        field: 'image_url',
        headerName: displayMessage('PHOTO'),
        width: 110,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div style={{ width: 100, height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={ params?.row?.Patient?.image_url } />
                </div>
            )
        }
    },
    {
        field: 'fullName',
        headerName: displayMessage('NAME'),
        width: 180,
        valueGetter: function (params) {
            return `${params?.row?.Patient?.full_name || ''}`
        }
    },
    {
        field: "current_duration_formatted",
        headerName: displayMessage('MIUTES_IN_ROOM'),
        tyle: "number",
        width: 120,
        align: "center",
        valueFormatter: function (params) {
            return `${params.value + 'min'}`
        }
    }
    
    // {
    //     field: 'email',
    //     headerName: 'Email',
    //     width: 200,
    //     valueGetter: function (params) {
    //         return `${params.row.email}`
    //     }
    // },


]